import React, {Component} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import {Cell, Legend, Pie, PieChart, Tooltip} from 'recharts'
import {Card, DatePicker, Select} from 'antd'
import _ from 'lodash'


import Request from '../../request'

import {connect} from 'react-redux'

const {RangePicker} = DatePicker
const {Option} = Select

const data = [
    {name: 'Group A', value: 525},
    {name: 'Group B', value: 175},
    {name: 'Group C', value: 300},
    {name: 'Group D', value: 200},
    {name: 'Group E', value: 200}
]


const COLORS = ['#faad14', '#52c41a', '#13c2c2', '#f759ab', '#120338']

const RADIAN = Math.PI / 180
const renderCustomizedLabel = ({
                                   cx, cy, midAngle, innerRadius, outerRadius, percent, index
                               }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5
    const x = cx + radius * Math.cos(-midAngle * RADIAN)
    const y = cy + radius * Math.sin(-midAngle * RADIAN)

    return (
        <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {`${(percent * 100).toFixed(0)}%`}
        </text>
    )
}

class GraphicalReport extends Component {

    reload = () => {
        this.getGraphData()
    }
    chooseRangerPicker = (date, dateString) => {
        this.setState({
            time: {
                key: 'time',
                from: date[0],
                to: date[1]
            }
        }, () => {
            console.log(this.state.time, '@@@@@@@@@@@@@@@@@@@')

        })


        if (date[0] === undefined) {
            setTimeout(() => {
                this.reload()
            }, 500)
        }
    }
    getGraphData = () => {

        let {time, studentBranchId, channelPartnerId, associativePartnerId, countryId} = this.state
        let obj = {studentBranchId, associativePartnerId, countryId, channelPartnerId, time}

        Request.graphicalReportData({filters: obj}).then(({data: chartData, total, allBranches}) => {
            this.setState({chartData, total, allBranches})
        })
    }

    constructor(props) {
        super(props)
        this.associatePartner()
        this.loadChannelPartners()
        this.loadCountries()
        this.state = {
            total: 0,
            loading: false,
            allAssociatePartner: [],
            channelPartnerList: [],
            allBranches: [],
            allcountries: []

        }
    }

    async associatePartner() {
        let params = {branchAssociatePartner: 'Associate Partner', sortField: 'branchName', results: 1000}
        let data = await Request.loadSimpleBranch({...params})
        let allAssociatePartner = []
        if (data && data.data && data.data.length) {
            _.each(data.data, (item) => {
                allAssociatePartner.push({value: item._id, text: item.branchName})
            })
            this.setState({allAssociatePartner})
        }

    }

    async loadChannelPartners() {
        let {data: channelPartnerList} = await Request.getSimplePartners({
            results: 10000
        })
        let partnerList = []
        _.each(channelPartnerList, (item) => {
            partnerList.push({value: item._id, text: item.channelPartnerName})
        })
        this.setState({channelPartnerList: partnerList})
    }

    async loadCountries() {
        let {data: countriesList} = await Request.getCountries({
            results: 10000
        })
        let countryList = []
        _.each(countriesList, (item) => {
            countryList.push({value: item._id, text: item.countryName})
        })
        this.setState({allcountries: countryList})
    }

    componentDidMount() {
        this.getGraphData()
    }

    render() {

        const {allBranches, allAssociatePartner, channelPartnerList, allcountries, chartData} = this.state

        return (
            <PageHeaderWrapper title={`
          Total : ${this.state.total}`}>
                <Card style={{marginBottom: 10}}>
                    <RangePicker
                        style={{
                            width: 300,
                            paddingRight: 16,
                            paddingBottom: '10px'
                        }}
                        showTime={{format: 'HH:mm'}}
                        format="YYYY-MM-DD HH:mm"
                        placeholder={['Start Time', 'End Time']}
                        onChange={this.chooseRangerPicker}
                        onOk={this.reload}
                    />
                    <Select
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        style={{
                            width: 200,
                            paddingRight: 16
                        }}
                        value={this.state.studentBranchId}
                        placeholder="All Branch"
                        onChange={branchId => {
                            this.setState(
                                {
                                    studentBranchId: branchId && branchId.toString()
                                },
                                () => {
                                    this.getGraphData()
                                }
                            )
                        }}>
                        {allBranches.map((val, idn) => {
                            return (
                                <Option key={idn} value={val.value}>
                                    {val.text}
                                </Option>
                            )
                        })}
                    </Select>
                    <Select
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        style={{
                            width: 200,
                            paddingRight: 16
                        }}
                        value={this.state.associativePartnerId}
                        placeholder="All Associate Partner"
                        onChange={associatePartnerId => {
                            this.setState(
                                {
                                    associativePartnerId: associatePartnerId && associatePartnerId.toString()
                                },
                                () => {
                                    this.getGraphData()
                                }
                            )
                        }}>
                        {allAssociatePartner.map((val, idn) => {
                            return (
                                <Option key={idn} value={val.value}>
                                    {val.text}
                                </Option>
                            )
                        })}
                    </Select>
                    <Select
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        style={{
                            width: 200,
                            paddingRight: 16
                        }}
                        value={this.state.channelPartnerId}
                        placeholder="All Channel Partner"
                        onChange={channelPartnerId => {
                            this.setState(
                                {
                                    channelPartnerId: channelPartnerId && channelPartnerId.toString()
                                },
                                () => {
                                    this.getGraphData()
                                }
                            )
                        }}>
                        {channelPartnerList.map((val, idn) => {
                            return (
                                <Option key={idn} value={val.value}>
                                    {val.text}
                                </Option>
                            )
                        })}
                    </Select>
                    <Select
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        style={{
                            width: 200
                        }}
                        value={this.state.countryId}
                        placeholder="All countries"
                        onChange={countryId => {
                            this.setState(
                                {
                                    countryId: countryId && countryId.toString()
                                },
                                () => {
                                    this.getGraphData()
                                }
                            )
                        }}>
                        {allcountries.map((val, idn) => {
                            return (
                                <Option key={idn} value={val.value}>
                                    {val.text}
                                </Option>
                            )
                        })}
                    </Select>
                </Card>

                {chartData && <Card bordered={true}>
                    <PieChart width={1000} height={420}>
                        <Pie
                            data={chartData}
                            cx={500}
                            cy={200}
                            labelLine={false}
                            label={renderCustomizedLabel}
                            outerRadius={200}
                            fill="#8884d8"
                            dataKey="value"
                        >
                            {
                                data.map((entry, index) => <Cell key={`cell-${index}`}
                                                                 fill={COLORS[index % COLORS.length]}/>)
                            }
                        </Pie>
                        <Legend wrapperStyle={{position: 'relative'}}/>
                        <Tooltip/>
                    </PieChart>
                </Card>}
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global}) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GraphicalReport)
